<div class="row error-wrapper">
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <div class="row flex items-center error-heading-wrapper">
      <span class="pseudo-icon heading-icon warning"></span>
      <h2 dsContent class="bold-header title-heading" [contentPath]="'claims.claimErrorHit'"></h2>
    </div>

    <div class="claim-help-body">
      <p dsContent [contentPath]="'claims.claimTechnicalError'"></p>
    </div>
  </div>

  <div
    class="row margin-top-50 sm-margin-top-0 column twelve lg-push-two md-eight md-push-two border-top call-action-btn"
  >
    <div class="call-action-btn-wrapper">
      <call-to-action
        [primaryButtonName]="errorBtnText"
        [capitalize]="true"
        [actionPanel]="true"
        [dsRouterLink]="routePath"
        [dsErrorAction]="true"
      ></call-to-action>
    </div>
  </div>
</div>
